module.exports = __webpack_public_path__ + "static/media/Apple iPhone XR Space Grey.21a21444.png";